import type { ButtonHTMLAttributes } from 'react'

import { cn } from '@/legacy-src/lib/utils'

import { Tag, type TagProps } from './Tag'

export interface ButtonTagProps
  extends Omit<TagProps, 'asChild' | 'children'>,
    ButtonHTMLAttributes<HTMLButtonElement> {}

export const ButtonTag = ({ size, variant, children, className, ...rest }: ButtonTagProps) => (
  <Tag
    size={size}
    variant={variant}
    active
    asChild
    className={cn(
      `appearance-none ring-offset-background transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:border-sand-400 disabled:bg-sand-400 disabled:!text-sand-700`,
      {
        'border-none': variant !== 'outline',
      },
      className,
    )}
  >
    <button {...rest}>{children}</button>
  </Tag>
)
